
import '../../shared/journey-ui/core';
import '../../shared/journey-ui/error';

export const vendor = [
  'ui.router',
  'journey-ui.shared.core',
  'journey-ui.shared.error'
];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/vendor.js